// from https://github.com/kentcdodds/use-deep-compare-effect
import * as React from "react";
import { useDeepCompareMemoize } from "..";
export function useDeepCompareCallback(callback, dependencies) {
    return React.useCallback(callback, useDeepCompareMemoize(dependencies));
}
//# sourceMappingURL=useDeepCompareCallback.js.map